import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";

export interface ConfirmDialogModel {
  title: string;
  message: string;
}

@Component({
  templateUrl: "./confirm-dialog.template.pug",
})
export class ConfirmDialogComponent extends DialogComponent<ConfirmDialogModel, boolean> implements ConfirmDialogModel {
  message: string;
  title: string;

  static showConfirmationDialogModal(dialogService: DialogService, inputs: ConfirmDialogModel):
  Observable<boolean> {
    return dialogService.addDialog(ConfirmDialogComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  ok(): void {
    this.result = true;
    this.close();
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
